import AddIcon from '@mui/icons-material/Add';
import Button from '../../../core-components/theme/components/Button/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ConfigureLogbookButton() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleOpen = () => {
        navigate('logbook-configuration/add');
    };

    return (
        <Button
            onClick={handleOpen}
            title={t('logbookConfig.configureLogbookTemplate', 'Configure Logbook Template')}
            variant="contained"
            aria-label={t('logbookConfig.chooseNewLogbookTemplate', 'Choose a new logbook template')}
        >
            <AddIcon />
            {!isMobile && t('logbookConfig.configureLogbookTemplate', 'Configure Logbook Template')}
        </Button>
    );
}